export default "__VITE_ASSET__Bmhj1ztx__"